import { statisticsPages } from '../../../constants/statisticsPages';
import { dspxDiffDays } from '../../../helpers/dspx-utils';

export const getPageRequests = (requests) => {
  const activeRequests = [];
  const immediateRequests = [];
  const expiredRequests = [];
  const retryRequests = [];
  const chargeableRequests = [];

  requests.forEach((request) => {
    const diff = request.doneDate
      ? dspxDiffDays(request.doneDate, request.executeTime)
      : dspxDiffDays(0, request.executeTime);

    if (request.statusId === 1) {
      activeRequests.push(request);
    }

    if (request.isImmediate) {
      immediateRequests.push(request);
    }

    if (diff > 0) {
      expiredRequests.push(request);
    }

    if (request.isRetry) {
      retryRequests.push(request);
    }

    if (request.isChargeable) {
      chargeableRequests.push(request);
    }
  });

  return {
    all: requests,
    [statisticsPages.active]: activeRequests,
    [statisticsPages.immediate]: immediateRequests,
    [statisticsPages.expired]: expiredRequests,
    [statisticsPages.retry]: retryRequests,
    [statisticsPages.chargeable]: chargeableRequests,
  };
};
